import { useState } from "react";

const ExpandHistory = ({ history }) => {
    const [expanded, setExpanded] = useState(false);
    if (!history || history.length === 0) return null;

    const latestFiveEntries = history.slice().reverse().slice(0, 5);
    const hasMoreEntries = history.length > 5;

    return (
        <div>
            <button
                onClick={() => setExpanded(e => !e)}
                style={{
                    background: "#f0f7fa",
                    border: "none",
                    borderRadius: "4px",
                    color: "#1976d2",
                    cursor: "pointer",
                    fontSize: 13,
                    padding: "4px 8px",
                    display: "flex",
                    alignItems: "center",
                    gap: "4px"
                }}
            >
                <span style={{ fontSize: 14 }}>
                    {expanded ? "▼" : "▶"}
                </span>
                {expanded ? "Hide History" : "Show History"}
            </button>
            {expanded && (
                <div style={{
                    marginTop: "8px",
                    maxHeight: "200px",
                    overflowY: "auto",
                    background: "#fafafa",
                    borderRadius: "4px",
                    border: "1px solid #f0f0f0",
                    padding: "8px"
                }}>
                    <ul style={{ paddingLeft: 0, margin: 0, fontSize: 13 }}>
                        {latestFiveEntries.map((h, idx) => (
                            <li key={idx} style={{
                                marginBottom: 6,
                                listStyle: "none",
                                display: "flex",
                                borderBottom: idx < latestFiveEntries.length - 1 ? "1px solid #f0f0f0" : "none",
                                paddingBottom: 6
                            }}>
                                <div style={{
                                    width: "80px",
                                    flexShrink: 0,
                                    marginRight: "8px",
                                    color: "#888",
                                    fontSize: "12px"
                                }}>
                                    {new Date(h.changed_date).toLocaleDateString()}
                                </div>
                                <div style={{ flex: 1 }}>
                                    <div style={{ display: "flex", alignItems: "center" }}>
                                        <span style={{
                                            fontWeight: 600,
                                            background: h.status === "Joined" ? "#e6f4ea" :
                                                h.status === "Requested" ? "#fff8e1" :
                                                    h.status === "Removed" ? "#ffeaea" : "#f0f0f0",
                                            padding: "1px 6px",
                                            borderRadius: "4px",
                                            fontSize: "12px",
                                            color: h.status === "Joined" ? "#22A06B" :
                                                h.status === "Requested" ? "#b38600" :
                                                    h.status === "Removed" ? "#d32f2f" : "#888",
                                        }}>
                                            {h.status}
                                        </span>
                                    </div>
                                    <div style={{ fontSize: "12px", marginTop: "2px" }}>
                                        by <span style={{ color: "#555", fontWeight: 500 }}>{h.changed_by}</span>
                                    </div>
                                </div>
                            </li>
                        ))}
                        {hasMoreEntries && (
                            <li style={{ fontSize: "12px", color: "#888", textAlign: "center", marginTop: "4px" }}>
                                + {history.length - 5} more entries
                            </li>
                        )}
                    </ul>
                </div>
            )}
        </div>
    );
};

export default ExpandHistory;